import { ProductsList } from "@/components/admin/ProductsList";

export default function AdminDashboard() {
  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold font-playfair mb-2">Products</h1>
        <p className="text-muted-foreground">
          Manage your product inventory
        </p>
      </div>

      <ProductsList />
    </div>
  );
}
